const SSE_RECONNECT_WARNING_THRESHOLD = 6;

export default () => ({
  connectionLost: false,
  init() {
    this.$watch('$store.sseReconnectAttempts', (attempts) => {
      this.connectionLost = attempts >= SSE_RECONNECT_WARNING_THRESHOLD;
    });
  },
});
